(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["landing-product-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      // Gift product slider
      const productSlidernew = new Swiper('.gift__product--slider', {
        slidesPerView: 2.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },    
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            freeMode: true,
            loop: false,
            spaceBetween: 18,
          },
          1022: {
            slidesPerView: 3.5,
            freeMode: true,
            loop: false,
            spaceBetween: 18,
          }
        }
      });
    });
    window.addEventListener("load", function(event) {
      if(!document.getElementById("gift__product--slider")) return
      let varWidth = document.getElementById("gift__product--slider").offsetWidth;
      document.getElementById('variable-vase').style.width=`${varWidth}px`;
    });

    window.addEventListener('resize', function(event){
      if(!document.getElementById("gift__product--slider")) return
      let varWidth = document.getElementById("gift__product--slider").offsetWidth;
      document.getElementById('variable-vase').style.width=`${varWidth}px`;
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      // Gift product slider
      const productSlidernew = new Swiper('.gift__product--slider', {
        slidesPerView: 2.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },    
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            freeMode: true,
            loop: false,
            spaceBetween: 18,
          },
          1022: {
            slidesPerView: 3.5,
            freeMode: true,
            loop: false,
            spaceBetween: 18,
          }
        }
      });
    });
    window.addEventListener("load", function(event) {
      if(!document.getElementById("gift__product--slider")) return
      let varWidth = document.getElementById("gift__product--slider").offsetWidth;
      document.getElementById('variable-vase').style.width=`${varWidth}px`;
    });

    window.addEventListener('resize', function(event){
      if(!document.getElementById("gift__product--slider")) return
      let varWidth = document.getElementById("gift__product--slider").offsetWidth;
      document.getElementById('variable-vase').style.width=`${varWidth}px`;
    });
  } catch(e) { console.error(e); }
})();

})();
